import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPostPageNew from "../../components/Post/ViewPostPageNew";



const UploadViewPostPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Upload Post" link2="/uploadpost" title="View Post" />

        {/* AddUserLayer */}
        <ViewPostPageNew />


      </MasterLayout>
    </>
  );
};

export default UploadViewPostPage;
